import React, { useState, useEffect } from "react";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import IdNameModel from "../../../../models/common/IdNameModel";
import CompanyProfilesDashboardModel from "../../../../models/admin/company/response/CompanyProfilesDashboardModel";
import CompanyProfilesDashboardSeachInputModel from "../../../../models/admin/company/request/CompanyProfilesDashboardSeachInputModel";
import { SortDirection } from "../../../../models/enums/SortDirectionEnum";
import modalUtils from "../../../../utils/modal-utils";
import loaderUtils from "../../../../utils/loader-utils";
import adminCompanyService from "../../../../services/admin/admin-company-service";
import toasterUtils from "../../../../utils/toaster-utils";
import CompanyProfilesDashboardGridComponent from "./CompanyProfilesDashboardGridComponent";
import { PagingEnum } from "../../../../models/enums/IAIEnum";
import masterDataService from "../../../../services/master-data-service";
import { GuidEnum } from "../../../../models/enums/GuidEnum";
import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

interface CompanyProfilesDashboardProps {
    companiesList: IdNameModel[];
};

const CompanyProfilesDashboardComponent = (props: CompanyProfilesDashboardProps) => {
    const [companyList, setCompanyList] = useState<CompanyProfilesDashboardModel[]>([]);
    const [recruiterList, setRecruiterList] = useState<IdNameModel[]>([]);
    const [refreshCompany, setRefreshCompany] = useState<number>(2);
    const [startDateSearch, setStartDateSearch] = useState<Dayjs | null>(dayjs().subtract(30, 'day'));
    const [endDateSearch, setEndDateSearch] = useState<Dayjs | null>(dayjs());
    const [companySearch, setCompanySearch] = useState<string>(GuidEnum.Empty);
    const [recruiterSearch, setRecruiterSearch] = useState<string>(GuidEnum.Empty);
    const [page, setPage] = useState<number>(PagingEnum.page);
    const [pageSize, setPageSize] = useState<number>(PagingEnum.pageSize);
    const [sortColumn, setSortColumn] = useState<string>("CompanyName");
    const [sortDirection, setSortDirection] = useState<number>(PagingEnum.sortDirection);
    const [pageSizesList, setPageSizesList] = useState<number[]>([]);

    useEffect(() => {
        loadPageSizes();
        clearSearch();
    }, []);

    const loadPageSizes = () => {
        masterDataService.loadPageSizesForPaging().then((res) => {
            setPageSizesList(res);
        }).catch((error) => {
            toasterUtils.showError(error);
        });
    };

    const loadRecruiters = (companyId: string) => {
        setCompanySearch(companyId);
        if (companyId !== "") {
            modalUtils.showLoader();
            adminCompanyService.getRecruiterByCompany(companyId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                setRecruiterSearch(GuidEnum.Empty);
                setRecruiterList(res.items);
            }).catch((error) => {
                setRecruiterSearch(GuidEnum.Empty);
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        } else {
            setRecruiterList([]);
            setRecruiterSearch(GuidEnum.Empty);
        }
    };

    const clearSearch = () => {
        setCompanyList([]);
        setStartDateSearch(dayjs().subtract(30, 'day'));
        setEndDateSearch(dayjs());
        setCompanySearch(GuidEnum.Empty);
        setRefreshCompany(2);
    };

    const getSerchFilters = (page: number, pageSize: number, sortColumn: string, sortDirection: number) => {
        var inputData: CompanyProfilesDashboardSeachInputModel = {
            startDate: startDateSearch ? startDateSearch.toDate() : new Date(),
            endDate: endDateSearch ? endDateSearch.toDate() : new Date(),
            companyId: companySearch === "" ? GuidEnum.Empty : companySearch,
            recruiterId: recruiterSearch === "" ? GuidEnum.Empty : recruiterSearch,
            page: page,
            pageSize: pageSize,
            sort: sortColumn,
            sortDir: sortDirection
        };
        return inputData;
    }

    const getCompanyDashboard = (inputData: CompanyProfilesDashboardSeachInputModel) => {
        if (startDateSearch === null || endDateSearch === null) {
            toasterUtils.showWarning("Please select Company, Start Date dnd End Date");
            return;
        } else if (startDateSearch > endDateSearch) {
            toasterUtils.showWarning("Start date cannot be greater than End Date");
            return;
        }
        setRefreshCompany(2);
        modalUtils.showLoader();
        adminCompanyService.getCompanyProfilesDashboard(inputData).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCompanyList([]);
            setCompanyList(res.items);
            setRefreshCompany(refreshCompany * 5);
        }).catch((error) => {
            setRefreshCompany(refreshCompany * 5);
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    const onPageChangeActionHandler = (newPage: number) => {
        setPage(newPage);
        getCompanyDashboard(getSerchFilters(newPage, pageSize, sortColumn, sortDirection));
    };

    const onPageSizeChangeActionHandler = (newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(PagingEnum.page);
        getCompanyDashboard(getSerchFilters(PagingEnum.page, newPageSize, sortColumn, sortDirection));
    };

    const onSortActionHandler = (newSortColumn: string, sortDir: string) => {
        setSortColumn(newSortColumn);
        setSortDirection(sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc);
        getCompanyDashboard(getSerchFilters(page, pageSize, newSortColumn, sortDir === "asc" ? SortDirection.Asc : SortDirection.Desc));
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <FormControl fullWidth margin="none" size="small">
                            <Autocomplete options={props.companiesList} value={props.companiesList.find((x) => x.guId === companySearch) || null}
                                onChange={(_, newValue) => loadRecruiters(newValue ? newValue.guId : GuidEnum.Empty)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                renderInput={(params) => (
                                    <TextField {...params} label="Company" size="small" margin="normal" fullWidth />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="col-md-3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Start Date"
                                value={startDateSearch}
                                onChange={(newValue) => setStartDateSearch(newValue)}
                                format="YYYY-MMM-DD"
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                        margin: "normal",
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="col-md-3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="End Date"
                                value={endDateSearch}
                                onChange={(newValue) => setEndDateSearch(newValue)}
                                format="YYYY-MMM-DD"
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        size: "small",
                                        margin: "normal",
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div className="col-md-3">
                        <FormControl fullWidth margin="none" size="small">
                            <Autocomplete options={recruiterList} value={recruiterList.find((x) => x.guId === recruiterSearch) || null}
                                onChange={(_, newValue) => setRecruiterSearch(newValue ? newValue.guId : GuidEnum.Empty)} getOptionLabel={(option) => option?.name || ""} isOptionEqualToValue={(option, value) => option.guId === value.guId}
                                renderInput={(params) => (
                                    <TextField {...params} label="Recruiter" size="small" margin="normal" fullWidth />
                                )}
                            />
                        </FormControl>
                    </div>
                    <div className="col-md-12 text-end">
                        <Button variant="contained" color="success" onClick={() => getCompanyDashboard(getSerchFilters(page, pageSize, sortColumn, sortDirection))} startIcon={<SearchIcon />} sx={{ ml: 2, mt: 2 }}>
                            Search
                        </Button>
                        <Button variant="contained" color="warning" onClick={() => clearSearch()} startIcon={<ClearIcon />} sx={{ ml: 2, mt: 2 }}>
                            Clear
                        </Button>
                    </div>
                </div>
                {companyList.length > 0 && refreshCompany > 2 &&
                    <CompanyProfilesDashboardGridComponent
                        key={refreshCompany}
                        companyList={companyList}
                        totalSize={companyList.length}
                        currentPage={page + 1}
                        pagesize={pageSize}
                        sortColumn={sortColumn}
                        sortDirection={sortDirection === SortDirection.Asc ? "asc" : "desc"}
                        pageSizesList={pageSizesList}
                        onPageChangeAction={onPageChangeActionHandler}
                        onPageSizeChangeAction={onPageSizeChangeActionHandler}
                        onSortAction={onSortActionHandler} />
                }
            </div>
        </div>
    );
};
export default CompanyProfilesDashboardComponent;